import { WeetProvider } from '@wepie/weet';
import { IPreviewerProps } from 'dumi';
import Previewer from 'dumi/theme-default/builtins/Previewer';

export default function CustomPreviewer(props: IPreviewerProps) {
  return (
    <WeetProvider>
      <Previewer {...props} />
    </WeetProvider>
  );
}
